// extracted by mini-css-extract-plugin
module.exports = {"iconLink":"src-hello-react-components-icon-link-icon-link__iconLink--29yuV","icon":"src-hello-react-components-icon-link-icon-link__icon--2ZK6L"};